<template>
  <SvgUse/>
  <MainHeader/>
  <router-view/>
</template>

<script>
import SvgUse     from '@/components/app/Use'
import MainHeader from '@/components/header/MainHeader'



export default {
  name: 'MainLayout',

  components: { SvgUse, MainHeader }
}
</script>